var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPersonPrimary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 19,
    viewBox: "0 0 18 19",
    fill: "current",
    strokeWidth: 0,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "wrapper"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Union",
    d: "M9.16667 9.38888C8.25 9.38888 7.48842 9.08564 6.88194 8.47917C6.27547 7.87268 5.97223 7.1111 5.97223 6.19444C5.97223 5.27777 6.27547 4.5162 6.88194 3.90973C7.48842 3.30324 8.25 3 9.16667 3C10.0833 3 10.8449 3.30324 11.4514 3.90973C12.0579 4.5162 12.3611 5.27777 12.3611 6.19444C12.3611 7.1111 12.0579 7.87268 11.4514 8.47917C10.8449 9.08564 10.0833 9.38888 9.16667 9.38888ZM2.5 16.0694V13.9861C2.5 13.4769 2.62847 13.0313 2.88542 12.6493C3.14236 12.2674 3.47685 11.9769 3.8889 11.7778C4.7963 11.3565 5.68287 11.0405 6.5486 10.8299C7.41435 10.6192 8.28704 10.5139 9.16667 10.5139C10.0463 10.5139 10.9167 10.6215 11.7778 10.8368C12.6389 11.0521 13.5231 11.3657 14.4306 11.7778C14.8519 11.9769 15.191 12.2674 15.4479 12.6493C15.7049 13.0313 15.8333 13.4769 15.8333 13.9861V16.0694H2.5Z",
    fill: ""
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonPrimary);
export default __webpack_public_path__ + "static/media/PersonPrimary.147bbfb8a011bbd0b3487bbd0edde7a7.svg";
export { ForwardRef as ReactComponent };